import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import { procedureAttachmentsRoute } from './steps/attachments.route';
import { procedureBaseRoute } from './steps/base.route';
import { procedureDataRoute } from './steps/data.route';
import { procedureDescriptionRoute } from './steps/description.route';

export function procedureManageRoute(path: string, name: string, title: string, steps: any[]): RouteConfig {
  return {
    path,
    name,
    component: () => import(/* webpackChunkName: "ProcedureManage" */ '@/views/mainRoute/procedure/Manage.vue'),
    meta: { breadcrumb: { title } },
    children: [
      procedureBaseRoute(`${name}Base`),
      procedureDataRoute(`${name}Data`),
      procedureAttachmentsRoute(`${name}Attachments`),
      procedureDescriptionRoute(`${name}Description`)
    ],
    props: { steps, title },
    redirect: { name: `${name}Base` },
    beforeEnter: (to, from, next) => {
      if (to.params.procedureId) {
        store
          .dispatch('procedure/get', tryParseInt(to.params.procedureId))
          .then(() => next())
          .catch(err => store.dispatch('notifyError', { title: Errors.PROCEDURE_CANNOT_GET }));
      } else {
        next();
      }
    }
  };
}
